import type { ReactNode } from 'react';
import { Marca } from '@shared/components/Marca';
import { curso } from '@curso/content/curso';

/**
 * Moldura das paginas avulsas: /sair e /privacidade.
 *
 * Fora da moldura de abas de proposito: sao tarefas ou textos unicos, e quem
 * chega aqui nao veio para ler sobre o curso. So a marca, que leva de volta
 * para a pagina principal.
 */
export function PaginaAvulsa({
  titulo,
  largura = 'max-w-xl',
  children,
}: {
  titulo: string;
  largura?: string;
  children: ReactNode;
}) {
  return (
    <div className="min-h-screen bg-papel-fundo">
      <header className="border-b border-linha bg-papel">
        <div className={`mx-auto flex h-14 w-full ${largura} items-center px-6`}>
          <a
            href="/"
            className="flex items-center gap-2.5 text-tinta"
            aria-label={`${curso.marca}, página inicial`}
          >
            <Marca tamanho={36} comLetras={false} className="shrink-0" />
            <span className="font-display text-[1.6rem] leading-none font-semibold tracking-tight">
              {curso.marca}
            </span>
          </a>
        </div>
      </header>

      <main className={`mx-auto w-full ${largura} px-6 py-12`}>
        <p className="rotulo">{curso.formato}</p>
        <h1 className="display-secao mt-3">{titulo}</h1>
        <div className="mt-6 border border-linha bg-papel p-7">{children}</div>
      </main>
    </div>
  );
}
